<template>
  <div>
    <div v-if="isMobile" class="new-payment-option-mobile">
      <div :class="paymentOption.mobileContainerClass()"
           @click="$emit('option-selected', paymentOption)"
           v-on:keyup.enter="$emit('option-selected', paymentOption)">
        <div>
          <span v-html="paymentOption.displayText"></span>
        </div>
        <div>{{paymentOption.totalAmount()}}</div>
        <div>{{paymentOption.frequencyAmount()}}</div>
      </div>
    </div>
    <div v-else class="new-payment-option">
      <div :class="paymentOption.frequencyClass()">{{paymentOption.frequencyAmount()}}</div>
      <div :class="paymentOption.totalAmountClass()">{{paymentOption.totalAmount()}}</div>
      <div :class="paymentOption.displayClass"
           @click="$emit('option-selected', paymentOption)"
           v-on:keyup.enter="$emit('option-selected', paymentOption)">
        <span v-html="paymentOption.displayText"></span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapState,
} from 'vuex';

export default {
  name: 'PaymentOption',
  props: {
    paymentOption: Object,
  },
  computed: {
    ...mapState(['isMobile']),
  },
};
</script>
<style lang="scss">
  @import '../styles/_mixins.scss';

  .new-payment-option {
    @include DefaultPoppinFont();
    cursor: pointer;
    display: flex;
    flex-flow: column;
    text-align:center;

    > div:nth-child(-n + 2) {
      @include DefaultBerlinskeFont();
      font-size: 29pt;
      padding-bottom: 2%;
    }

    > div.smaller-monthly {
      font-size: 15pt;
      color: #a8a5a5
    }

    > div.frequency-amount-monthly {
      color: $purple;
    }

    > div.frequency-amount-annual, > div.frequency-amount-cc {
      color: transparent;
    }

    .new-options-dd-annual, .new-options-cc, .new-options-dd-monthly {
      color: white;
      height:200px;
      max-height:200px;
      display:flex;
      align-items:center;
      justify-content:center;
      flex-grow:0;
      > span {
        font-family: inherit;
      }
    }

    .new-options-dd-annual {
      background-color: $darkpurple;
    }

    .new-options-dd-monthly {
      background-color: $purple;
      padding: 5% 2%;
      font-size: 1.4em;
    }

    .new-options-cc {
      background-color: $darkblue;
    }

    .total-amount-annual {
      color: $darkpurple;
    }

    .total-amount-cc {
      color: $darkblue;
    }

    > div:last-child:hover {
      font-style: italic;
      font-weight: bold;
    }
  }

  .new-payment-option-mobile {
    @include DefaultPoppinFont();
    cursor: pointer;

    div span {
      font-family: inherit;
    }

    .container-annual, .container-monthly, .container-cc {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      padding: 8% 2%;
      margin: 2%;
      text-align: left;
      color: white;

      > div:nth-child(1) {
        width: 65%;
      }

      > div:nth-child(2) {
        width: 35%;
        @include DefaultBerlinskeFont();
      }

      > div:nth-child(3) {
        @include DefaultBerlinskeFont();
        width: 100%;
        color: transparent;
      }
    }

    .container-annual {
      background: linear-gradient(to right, $darkpurple 50%, #75496d 100%);
    }

    .container-monthly {
      background: linear-gradient(to right, $purple 50%,#cc689d 100%);

      > div:nth-child(3) {
        color: #a8a5a5;
      }
    }

    .container-cc {
      background: linear-gradient(to right, $darkblue 50%, #2f3661 100%);
    }

    > div:hover {
      font-style: italic;
      font-weight: bold;
    }
  }
</style>
